document.addEventListener('click', function(e) {
  var btn = e.target.closest('.dynamic-variant-button');
  if (!btn) return;

  setTimeout(function() {
    var variantId = document.querySelector('[data-variant-select]')?.value;
    var xflowBtn = document.querySelector('xflow-bis-button');
    var productId = xflowBtn?.dataset?.productId;

    if (!variantId || !productId) return;

    window.XFLOW.pubSub.publish(
      window.XFLOW.vars.events.variantChange,
      {
        variantId: parseInt(variantId),
        productId: parseInt(productId)
      }
    );
  }, 100);
});
